module.exports = __webpack_public_path__ + "static/media/05-icon.3e1dc599.svg";